import { render, staticRenderFns } from "./TemplateSelectDlg.vue?vue&type=template&id=5a675ad8"
import script from "./TemplateSelectDlg.vue?vue&type=script&lang=js"
export * from "./TemplateSelectDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports